var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.display)?_c('div',{attrs:{"id":"loader"}},[_c('div',{attrs:{"id":"background"}}),_c('div',{attrs:{"id":"content"}},[_c('div',[_c('loaderAnimation')],1)])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }